export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.enterprise-overview': '企業概覽',
  'menu.organization-structure': '組織架構',
  'menu.organization-structure.members-and-departments': '成員與部門',
  'menu.organization-structure.role-management': '角色管理',
  'menu.cost-center': '費用中心',
  'menu.cost-center.my-subscription': '我的訂閱',
  'menu.cost-center.purchase-catalog': '套餐購買',
  'menu.cost-center.entitlements-upgrade': '權益升級',
  'menu.cost-center.my-products': '我的產品',
  'menu.cost-center.seat-allocation': '席位分配',
  'menu.cost-center.entitlements': '權益數據',
  'menu.cost-center.orders': '訂單列表',
  'menu.cost-center.invoices': '發票管理',
  'menu.ai-usage': 'AI 使用管理',
  'menu.ai-usage.usage-overview': '用量概覽',
  'menu.ai-usage.usage-details': '用量詳情',
  'menu.ai-usage.usage-logs': '用量日誌',
  'menu.ai-usage.quota-management': '限額管理',
  'menu.ai-usage.storage-space': '存儲空間',
  'menu.ai-usage.storage-space.capacity-overview': '容量概覽',
  'menu.ai-usage.storage-space.storage-cleanup': '存儲清理',
  'menu.ai-usage.storage-space.limit-management': '上限管理',
  'menu.enterprise-culture': '企業文化',
  'menu.enterprise-culture.brand-config': '品牌配置',
  'menu.enterprise-settings': '企業設置',
  'menu.enterprise-settings.enterprise-info': '企業信息',
  'menu.enterprise-settings.admin-permissions': '管理員權限',
  'menu.bot-management': '機器人管理',
  'menu.receive-management': '消息接收管理',
  'menu.receive-management.receive-config': '基本接收管理',
  'menu.receive-management.bot-config': '機器人接收管理',
  'menu.receive-management.category-management': '消息分類管理',
  'menu.roles-and-permissions': '角色與權限',
  'menu.roles-and-permissions.permission-management': '權限管理',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
